import styled from 'styled-components';
import { transparentize } from 'polished';
import transparency from '~/assets/defaults/bg-transparency.png';

interface IBanner {
  color: string;
}

interface INurseryTitle {
  color: string;
  opened: boolean;
}

interface IFolderRow {
  color: string;
  opened: boolean;
}

interface ICollapse {
  opened: boolean;
}

export const Container = styled.div`
  font-family: 'Poppins';
  h1 {
    margin-top: 122px;
    color: #202020;
  }
  h2,
  p {
    color: #707070;
  }

  .bg-name {
    border-radius: 16px;
    border: 1px solid #e8e8e8;
    background: #f9f9f9;
  }

  .all::-webkit-scrollbar-thumb {
    background-color: transparent !important;
    border-radius: 4px;
  }

  @media screen and (min-width: 992px) {
    h1 {
      margin-top: 22px;
    }
  }

  @media screen and (min-width: 1400px) {
    h1 {
      margin-top: 122px;
    }
  }
`;

export const NurseryTitle = styled.button<INurseryTitle>`
  background: ${(props) => props.color};
  border: none;
  border-radius: 16px;
  transition-duration: 0.3s;

  h2 {
    color: #fff;
  }

  .arrow {
    color: #fff;
    transition-duration: 0.3s;
    transform: rotateZ(${(props) => (props.opened ? '0' : '-90deg')});
  }
`;

export const FolderRow = styled.button<IFolderRow>`
  background: ${(props) =>
    props.opened ? transparentize(0.88, props.color) : '#f5f5f5'};
  border: none;
  border-radius: 16px;
  transition-duration: 0.3s;
  text-align: left;

  span {
    color: ${(props) => (props.opened ? props.color : '#707070')};
    font-weight: ${(props) => (props.opened ? 600 : 400)};
    transition-duration: 0.3s;
  }

  .arrow {
    color: ${(props) => (props.opened ? props.color : '#707070')};
    transition-duration: 0.3s;
    transform: rotateZ(${(props) => (props.opened ? '90deg' : '0')});
  }

  :hover {
    background: ${(props) =>
      props.opened ? transparentize(0.82, props.color) : '#ececec'};
  }
`;

export const Collapse = styled.div<ICollapse>`
  overflow: hidden;
  max-height: ${(props) => (props.opened ? '3000px' : '0px')};
  opacity: ${(props) => (props.opened ? 1 : 0)};
  transition: max-height 0.35s ease-in-out, opacity 0.25s ease-in-out;
`;

export const BannerTrasparency = styled.div<IBanner>`
  background: url(${transparency}),
    linear-gradient(
      180deg,
      ${(props) => props.color} 0%,
      ${(props) => props.color} 100%
    );
  /* background: ${(props) => props.color}; */
  background-size: cover;
  background-position: bottom center;
  background-repeat: no-repeat;
  border-radius: 8px;
  height: 26vw;
  width: 100%;
  min-height: 205px;
  max-height: 225px;
  margin-left: 10px;
  margin-right: 10px;

  @media screen and (min-width: 992px) {
    width: 31%;
    margin-left: 10px;
    margin-right: 10px;
  }
`;
